import View from 'views/base/view';
import ChatIframeTemplate from './templates/chat-iframe';

const ChatIframeContentView = View.extend({
  noWrap: true,
  autoRender: true,
  initialize: function(options) {
    this.data = options.data;
    this.template = ChatIframeTemplate;
    View.prototype.initialize.apply(this, arguments);
  },

  getTemplateData: function() {
    return this.data;
  },

  getTemplateFunction() {
    return this.template;
  }
});

export default ChatIframeContentView;
